import React, { useEffect, useState } from "react";
import { Button, Row, Col, notification } from "antd";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import logo from "../../assets/images/my-friend-logo.png";
import strings from "../../constants/constants";
import { componentStyles } from "./LandingPageStyles";
import { useNavigate, useLocation } from "react-router-dom";
import welcomeText from "../../assets/images/Ellipse 35.svg";
import { getScriptStatus, getUserSubscriptionDetails } from "../../api/password";
import { isNull } from "lodash";
import group3 from "../../assets/images/Group_3.svg";
import lesiure from "../../assets/images/leisure.svg";
import wellnessJournal from "../../assets/images/wellness-journal.svg";
import group5 from "../../assets/images/Group_5.svg";
import { getRequest } from "../../api";
import ClipLoader from "react-spinners/ClipLoader";
import styled from "styled-components";

function LandingPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [gettingToKnowScriptStatus, setGettingToKnowScriptStatus] = useState(false);
  const [responseLoading, setResponseLoading] = useState(true);
  const [userId, setUserId] = useState('');
  const [avatar, setAvatar] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedVoice1, setSelectedVoice1] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const initializeComponent = async () => {
      const stateUserId = location.state?.userId;
      const storedUserId = localStorage.getItem("userid");
      const id = stateUserId || storedUserId || '';
      setUserId(id);

      await Promise.all([
        checkGettingToKnowYouScriptStatus(),
        fetchAvatar(Number(id), setSelectedVoice1)
      ]);

      setLoading(false);
    };

    initializeComponent();
  }, [location.state]);

  const fetchAvatar = async (userId, setSelectedVoice1) => {
    try {
      const response = await getRequest('/user/get-avatar');

      if (response.error) {
        console.error("Error fetching avatar:", response.error);
        setSelectedVoice1(false);
      } else {
        const avatar = response.avatar;
        if (avatar === 'Amy' || avatar === 'Arthur' || avatar === 'Sam') {
          setAvatar(avatar);
          setSelectedVoice1(true);
        } else {
          setSelectedVoice1(false);
        }
      }
    } catch (error) {
      console.error("Error fetching avatar:", error);
      setSelectedVoice1(false);
    }
  };

  useEffect(() => {
    const id = localStorage.getItem("userid");
    const userId = Number(id);
    if (userId) {
      fetchAvatar(userId, setSelectedVoice1);
    } else {
      console.error("User ID is missing in localStorage.");
      setSelectedVoice1('Amy');
    }
  }, []);

  const checkGettingToKnowYouScriptStatus = async () => {
    try {
      const response = await getScriptStatus();
      if (!isNull(response.conversation)) {
        response?.conversationCompleted && setGettingToKnowScriptStatus(true);
        setResponseLoading(true);
      } else {
        setGettingToKnowScriptStatus(false);
        setResponseLoading(true);
      }
    } catch (err) {
      console.log("In catch", err);
    }
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  const handleConversationButtonClick = async () => {
    if (!userId) {
      console.error("User ID not available");
      return;
    }

    try {
      const response = await getUserSubscriptionDetails();

      if (response.message === "No subscriptions") {
        notification.error({
          message: "Subscription Required",
          description:
            "You don't have any subscription. Please subscribe to continue.",
          placement: "topRight",
          duration: 8,
        });
        navigate("/subs2");
        return;
      }

      const { planName, trialEndDate, planStatus } = response;
      const currentDate = new Date();
      const trialEnd = new Date(trialEndDate.split("/").reverse().join("-"));
      if (planName === "Monthly Plan" || planName === "Yearly Plan") {
        if (["past_due", "incomplete", "pending", "paused"].includes(planStatus)) {
          notification.error({
            message: "Plan Status Notification",
            description: `Your plan has ${planStatus} status. You cannot proceed further. Please update your subscription.`,
          });
          return; 
        } else if (["incomplete_expired", "expired", "canceled", "unpaid", "payment_failed"].includes(planStatus)) {
          navigate("/free-trial", {
            state: {
              message: `Your ${planName} has ended due to ${planStatus}. Please click on the button below to explore available subscription options and continue enjoying our services.`,
              header: `You ${planName} has ${planStatus} status.`,
            },
          });
        } else if (["trialing", "active"].includes(planStatus)) {
          if (avatar === "Sam") {
            gettingToKnowScriptStatus
              ? navigate("/text-conversation?type=openConversation", {
                  state: { userId: userId },
                })
              : navigate("/text-conversation?type=gettingToKnowYou", {
                  state: { userId: userId },
                });
          } else {
            if (selectedVoice1) {
              gettingToKnowScriptStatus
                ? navigate("/conversation?type=openConversation", {
                    state: { userId: userId },
                  })
                : navigate("/conversation?type=gettingToKnowYou", {
                    state: { userId: userId },
                  });
            } else {
              navigate("/voice-selection", { state: { userId: userId } });
            }
          }
        }
      } else if (planName === "Free Plan") {
        if (currentDate <= trialEnd) {
          if (avatar === "Sam") {
            gettingToKnowScriptStatus
              ? navigate("/text-conversation?type=openConversation", {
                  state: { userId: userId },
                })
              : navigate("/text-conversation?type=gettingToKnowYou", {
                  state: { userId: userId },
                });
          } else {
            if (selectedVoice1) {
              gettingToKnowScriptStatus
                ? navigate("/conversation?type=openConversation", {
                    state: { userId: userId },
                  })
                : navigate("/conversation?type=gettingToKnowYou", {
                    state: { userId: userId },
                  });
            } else {
              navigate("/voice-selection", { state: { userId: userId } });
            }
          }
        } else {
          navigate("/free-trial", {
            state: {
              message: "We hope you have enjoyed talking to My Friend over the last week, if you would like to continue doing so and access more of our features. Click on the button below to view the subscription options available to you.",
              header: "You have completed your one week free trial."
            },
          });
        }
      } else {
        console.error("Unknown plan type");
      }
    } catch (err) {
      console.error("Error fetching subscription details:", err);
    }
  };
  const handleAvatarButtonClick = () => {
    navigate("/avatar-settings", { state: { userId: userId } });
  }

  const handleNews = () => {
    navigate("/additional-services", { state: { backgroundColor: "#BB261A", message: 'Stay up to date with the world!', modalTitle: "News", type: "news" } });
  };

  const handleFinance = () => {
    navigate("/finance", { state: { backgroundColor: "#A5A7D0", message: 'Manage your finances all in one place!', modalTitle: "Financial", type: "financial" } });
  };

  const handleWellnessJournal = () => {
    navigate("/wellness-journal");
  };

  const handleLesiure = () => {
    navigate("/additional-services", { state: { backgroundColor: "#E1C16E", message: 'Leisure Page!', modalTitle: "Leisure", type: "leisure" } });
  };

  const ImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    @media (max-width: 767px) {
      flex-direction: row;
      justify-content: center;
      margin-top: 10px;
    }`;

  return (
   <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={{ marginBottom: 10 }}
        >
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <ClipLoader
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <Row
            style={componentStyles.padding}
            align={"middle"}
            justify={"center"}
          >
            <Col
              flex="90%"
              xs={{ span: 24 }}
              sm={24}
              lg={{ span: 18 }}
              md={{ span: 16 }}
              style={componentStyles.startSectionDesign}
            >
              <Row style={componentStyles.spacingBottom}>
                <Col span={12} style={componentStyles.content}>
                  <div style={componentStyles.imageContainer}>
                    <img
                      src={welcomeText}
                      alt="Welcome Text"
                      style={componentStyles.imageStyling}
                    />
                    <p style={componentStyles.textStyle}>
                      {gettingToKnowScriptStatus
                        ? strings.landingPageOtherHeader
                        : strings.landingPageHeader}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", height: "85%" }}>
                  <Col
                    xs={0}
                    sm={0}
                    md={24}
                    lg={24}
                    style={componentStyles.logoPadding}
                  >
                    <img
                      src={logo}
                      alt="landing page image"
                      style={componentStyles.largeImage}
                    />
                  </Col>
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  style={componentStyles.secondCol}
                >
                  <Row gutter={24} style={{display: "flex", justifyContent: "center"}}>
                    <Button
                      onClick={handleConversationButtonClick}
                      style={
                        !responseLoading
                          ? componentStyles.disabledButtonStyle
                          : componentStyles.buttonStyle2
                      }
                      disabled={!responseLoading}
                    >
                      <>Let's Start</>
                    </Button>
                    <Button
                      onClick={handleAvatarButtonClick}
                      style={
                        !responseLoading
                          ? componentStyles.disabledButtonStyle
                          : componentStyles.buttonStyle
                      }
                      disabled={!responseLoading}
                    >
                      <>Change Avatar</>
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col
              flex="10%"
              xs={{ span: 24 }}
              sm={24}
              lg={{ span: 8 }}
              md={{ span: 8 }}
              style={{ marginLeft: "8%" }}
            >
              <ImageContainer>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={handleWellnessJournal}
                  src={wellnessJournal}
                  alt="Wellness Journal"
                />
                <img
                  style={{ cursor: "pointer" }}
                  onClick={handleNews}
                  src={group3}
                  alt="Third Image"
                />
                <img
                  style={{ cursor: "pointer" }}
                  onClick={handleFinance}
                  src={group5}
                  alt="Fifth Image"
                />
                <img
                  style={{ cursor: "pointer"}}
                  onClick={handleLesiure}
                  src={lesiure}
                  alt="Fifth Image"
                />
              </ImageContainer>
            </Col>
          </Row>
        )}
      </Col>
    </div>
  );
}

export default LandingPage;